/* global globalThis */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PopupTypes } from '../../components/Popup';
import { DataTip, T } from '../../components/Translations';
import { ApiUrl, AppPages, Defines, StoreKeys, UserRoles } from '../../project/Defines';
import { Project } from '../../project/Project';
import { dispatchCustomEvent, EVENT_NAME, useCustomEvent } from '../../project/utilities';
import Badge from '../../Shared/Badge';
import DetailView from '../../Shared/DetailView';
import { FieldGroup } from '../../Shared/Form/formFields';
import InputCont from '../../Shared/Form/InputCont';
import { TabStrip } from '../../Shared/TabStrip';
import useDetail from '../../Shared/useDetail';
import { openPopup } from '../../store/actions';
import DPC from '../Documents/DPC';
import Fees from '../Documents/Fee';
import SpareParts from '../Documents/SparePart';
import { ACCEPT, onAcceptRejectCall, REJECT } from './AcceptRejectCall';
import Attachments from './Attachment';
import Customer from './Customer';
import DefectCodes from './DefectCodes';
import Product from './Product';
import Remark from './Remark';
import moment from 'moment';
import History from './History';
import Installer from './Installer';

// import { Ajax } from '../../components/Ajax';
import { message } from 'antd';

import { Switchable } from '../../Shared/Switchable';

const defaultValidationFields = [{ name: 'email', rules: [{ type: 'email' }] }];
const listUpdateEvent = EVENT_NAME.SERVICE_CALL_LIST_UPDATE;
const NETWORKCODE = "networkCode";
const arrStatusId = ['-2', '3', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25' ];
const arrCatoStatusId = ['-3', '1', '4', '5', '6', '7', '26', '27', '28' ]; // added 4, 6, 7
const disabledCatoStatusId = ['-1', '1', '2', '4', '5', '6', '7', '28' ]; // Checked  = -1; Closed = 2;
const disabledSpecialStatusId = ['-1', '2']; // Checked  = -1; Closed = 2;

const requiresSubStatus = (statusId) => {
  return statusId === "5" || statusId === "6" || statusId === "27" || statusId === "28";
};

const statusIdByName = {
  open: '-3',
  pending: '-2',
  closed: '-1',
  completed: '1'
};

const getStatusId = (statusId) => {
  const value = statusId?.target?.value ?? statusId;
  const normalizedValue = String(value);
  return statusIdByName[normalizedValue.toLowerCase()] || normalizedValue;
};
/**
 * @exports ServiceCallsDetails
 */
function ServiceCallsDetails(props) {
  const history = useHistory();
  const [validationFields, setValidationFields] = useState([...defaultValidationFields]);
  const [tabIndex, setTabIndex] = useState(0);
  // const [feeData, setFeeData] = useState({});
  // const [sparePart, setSparePart] = useState({});
  const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);
  const [statusHistory, setStatusHistory] = useState([]);
  const [savedStatusId, setSavedStatusId] = useState(null);
  const { id } = useParams();
  const { windowKey, data, openPopup, dispatch, role, canCreateCall, enableServiceContract, internalConnectAs, /*culture*/ } = props;
  const isCallCenter = role === UserRoles.CALL_CENTER;
  const isDispatcher = role === UserRoles.DISPATCHER;
  const isAdmin = isCallCenter || isDispatcher;
  const isSat = role === UserRoles.USER;
  const isInternalConnectAs = Boolean(internalConnectAs);
  const disabled = false;
  const currentNetworkRole = (localStorage.getItem(StoreKeys.CurrentNetworkRole) || '').replace(/^"|"$/g, '').trim().toLowerCase();
  const isReadOnlyRole = currentNetworkRole.includes('readonlyuser');
  //const isReadOnlyUser = isReadOnlyRole || canCreateCall === false;
 // const disabled = isReadOnlyUser;
  const networkCode = JSON.parse(localStorage.getItem(NETWORKCODE));

  const useDetailResult = useDetail({
    data: data || { ID: id === "create" ? null : id },
    updateUrl: ApiUrl.ServiceCallUpdate,
    windowKey,
    dataLoadUrl: ApiUrl.ServiceCallLoad,
    nameField: 'code',
    deleteUrl: ApiUrl.ServiceCallDelete,
    backPage: AppPages.ServiceCalls,
    listUpdateEvent,
    reloadEvent: EVENT_NAME.SERVICE_CALL_RELOAD,
    validationFields,
    onLoadData: (response, setDataItem) => {
      setSavedStatusId(response?.status_id ?? null);
      setDataItem(prev => ({
        ...(prev || {}),
        ...response,
        created_at_local: moment.utc(response?.created_at).local().format(),
        end_date: (prev?.end_date) ?? response?.end_date // safe optional chaining
      }));
      return true;
    },
    changingValidation: true,

    // detailUrl: Project.getPageUrl(AppPages.ServiceCallsDetails)
  });
  const { isNew, dataItem, setDataItem, updateData, detailRef, onChangeData, validation } = useDetailResult;

  const onCallResponded = (e) => {
    if (e?.detail?.type === ACCEPT) {
      dispatchCustomEvent(EVENT_NAME.SERVICE_CALL_RELOAD);
    } else if (e?.detail?.type === REJECT) {
      history.replace(Project.getPageUrl(AppPages.ServiceCalls));
    }
  };

  useCustomEvent(EVENT_NAME.SERVICE_CALL_UPDATED, onCallResponded);

  const updateSuccessCallback = (response) => {
    if (detailRef.current) {
      setSavedStatusId(response?.status_id ?? null);
      setDataItem({ ...response, created_at_local: moment.utc(response.created_at).local().format() });
    }

    dispatchCustomEvent(listUpdateEvent, { action: 'update' });
    dispatchCustomEvent([EVENT_NAME.ATTACHMENTS_LIST_UPDATE, EVENT_NAME.FEE_LIST_UPDATE, EVENT_NAME.SPARE_PART_LIST_UPDATE, EVENT_NAME.DPC_LIST_UPDATE, EVENT_NAME.HISTORY_LIST_UPDATE].join(" "), { action: 'update' });
  };

  const unassignSubcontractor = e => {
    openPopup({
      windowKey: 'wndConfirmUnassign',
      type: PopupTypes.Confirm,
      title: <T >{'text.unassign_subcontractor'}</T>,
      text: <T> message.delete_confirm </T>,
      buttonYesText: <T>{"text.unassign"}</T>,
      buttonNoText: <T>{"text.cancel"}</T>,
      yesCallback: () => updateData(updateSuccessCallback, null, { overrideData: { ...dataItem, update_type: 'unassign' } })
    });
  };
  const onAccept = (e) => {
    onAcceptRejectCall({ type: ACCEPT, data: dataItem, listUpdateEvent, dispatch });
  };

  const onReject = (e) => {
    onAcceptRejectCall({ type: REJECT, data: dataItem, listUpdateEvent, dispatch });
  };

  const onSendEmail = () => {
    openPopup({
      windowKey: "wndSendEmail",
      title: 'text.send_email',
      type: PopupTypes.EmailForm,
      bodyProps: { record: dataItem },
      fullScreen: false
    });
  };

  const openCreateCallDetail = () => {
    openPopup({
      windowKey: "wndCreateCall",
      title: 'text.duplicate_call',
      type: PopupTypes.CreateCall,
      bodyProps: { record: dataItem, isDuplicate: true, isSat: isSat },
      fullScreen: true
    });
    /** // history.push(Project.getPageUrl(AppPages.ServiceCallsDetails) + '/create'); */
  };


  const { accepted_at, is_saved_status_open, installer_name_required, installer_company_required, installer_zip_code_required, installer_city_required, installer_street_required, installer_phone_required, installer_email_required, installation_date_required } = dataItem || {};

  useEffect(() => {
    let fields = [...defaultValidationFields];

    if (dataItem?.installer_name_required) {
      fields.push('installer_name');
    }
    if (dataItem?.installer_company_required) {
      fields.push('installer_company');
    }
    if (dataItem?.installer_zip_code_required) {
      fields.push('installer_zip_code');
    }
    if (dataItem?.installer_city_required) {
      fields.push('installer_city');
    }
    if (dataItem?.installer_street_required) {
      fields.push('installer_street');
    }
    if (dataItem?.installer_phone_required) {
      fields.push('installer_phone');
    }
    if (dataItem?.installer_email_required) {
      fields.push('installer_email');
    }
    if (dataItem?.installation_date_required) {
      fields.push('installation_date');
    }

    if (accepted_at && is_saved_status_open) {
      fields.unshift('appointment_date_at');
    }

    setValidationFields(fields);
  }, [accepted_at, is_saved_status_open, installer_name_required, installer_company_required, installer_zip_code_required, installer_city_required, installer_street_required, installer_phone_required, installer_email_required, installation_date_required]); // eslint-disable-line react-hooks/exhaustive-deps

  const openDescriptionPopup = (e) => {
    // debugger;
    const statusId = getStatusId(e);
    /*eslint-disable-next-line*/
    if (dataItem.status === "Open" && statusId == "5") {
      openPopup({
        windowKey: "wndDescription",
        title: 'text.comment',
        type: PopupTypes.DescriptionForm,
        bodyProps: { record: { ...dataItem, status_id: statusId }, setDataItem, dataItem, onChangeData, updateData, detailRef },
        fullScreen: false,
        //saveCallback: () => updateData(updateSuccessCallback, null, { overrideData: { ...dataItem}})//, description_sat: 'unassign' } })
      });
    }
  }

  // useEffect(() => {
  //   if (dataItem && (isDispatcher || isSat)) {
  //     const _filterData = { call_id: dataItem?.call_id };
  //     const filterData = JSON.stringify(_filterData);

  //     Ajax.post({
  //       url: ApiUrl.FeeList,
  //       data: { filterData },
  //       success: function (response) {
  //         if (response) {
  //           const data = response.Data;
  //           const _feeData = data.filter(d => d?.callData?.call_id === dataItem?.call_id)[0];
  //           setFeeData(_feeData);
  //         }
  //       },
  //       error: function () {
  //         message.error("Error API Fee.")
  //       }
  //     });

  //     Ajax.post({
  //       url: ApiUrl.SparePartList,
  //       data: { filterData },
  //       success: function (response) {
  //         if (response) {
  //           const data = response.Data;
  //           const _sparePart = data.filter(d => d?.callData?.call_id === dataItem?.call_id)[0];
  //           setSparePart(_sparePart);
  //         }
  //       },
  //       error: function () {
  //         message.error("Error API SparePart.")
  //       }
  //     });
  //   }
  // }, [dataItem, isDispatcher, isSat]);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(globalThis.innerWidth <= 768);
    };
    
    globalThis.addEventListener('resize', handleResize);
    return () => globalThis.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (dataItem?.status_id && requiresSubStatus(dataItem.status_id)) {
      if (!dataItem.sub_status) {
        setDataItem(prev => ({ ...prev, sub_status: 'Por completar', sub_status_id: '-2' }));
      }
    } else {
      setDataItem(prev => ({ ...prev, sub_status: '', sub_status_id: '' }));
    }
  }, [dataItem?.status_id, dataItem?.sub_status_id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Load and sync status history from dataItem.status_history whenever it changes
  useEffect(() => {
    if(networkCode !== "YGNITA") {
      if (dataItem?.status_history) {
        try {
          const parsed = JSON.parse(dataItem.status_history);
          if (Array.isArray(parsed)) {
            setStatusHistory(parsed);
          } else {
            setStatusHistory([]);
          }
        } catch (e) {
          setStatusHistory([]);
        }
      } else {
        setStatusHistory([]);
      }
    }
  }, [dataItem?.status_history]); // eslint-disable-line react-hooks/exhaustive-deps

  const onYgnitaStatusChange = (newStatusId) => {
    newStatusId = getStatusId(newStatusId);

    /*eslint-disable-next-line*/
    if (dataItem?.fictive_serial_number && newStatusId == 1) {
      message.warning(<T>message.status_validation_for_fictive_serial_number</T>);
      return;
    }

    if (newStatusId === '1') {
      let endDate = moment(new Date(), Defines.Format.MomentDateTime).format(Defines.Format.MomentDateTime)
      setDataItem(prev => {
        const updated = { ...prev, end_date: endDate };
        return updated;
      });
    }

    setDataItem(prev => {
      const updated = { ...prev, status_id: newStatusId };
      return updated;
    });
  };

  const onStatusChange = (newStatusId) => {
    newStatusId = getStatusId(newStatusId);
    /*eslint-disable-next-line*/
    // if ((!isNotValidated || !isNotValidatedSparePart) && dataItem?.status_id == '1' && e == 2) {
    //   message.warning(<T>text.status_validation</T>);
    //   return;
    // }
    /*eslint-disable-next-line*/
    if (dataItem?.fictive_serial_number && newStatusId == 1) {
      message.warning(<T>message.status_validation_for_fictive_serial_number</T>);
      return;
    }
    
    if (newStatusId === '1') {
      let endDate = moment(new Date(), Defines.Format.MomentDateTime).format(Defines.Format.MomentDateTime)
      setDataItem(prev => {
        const updated = { ...prev, end_date: endDate };
        return updated;
      });
    } 

    const currentStatusId = dataItem?.status_id;

    setStatusHistory(prev => {
      const newHistory = [
        ...prev,
        {
          from: currentStatusId,
          to: newStatusId,
          changedAt: new Date().toISOString()
        }
      ];
      return newHistory;
    });

    setDataItem(prev => {
      const historyEntry = {
        from: prev?.status_id,
        to: newStatusId,
        changedAt: new Date().toISOString()
      };

      const updatedData = {
        ...prev,
        status_id: newStatusId,
        sub_status: '',
        sub_status_id: '',
        status_history: JSON.stringify([...(JSON.parse(prev?.status_history || '[]')), historyEntry])
      };

      return updatedData;
    });
  }
  
  const backpreviousStatus = () => {
    // Show confirmation popup before going back to previous status
    openPopup({
      windowKey: 'wndConfirmBackStatus',
      type: PopupTypes.Confirm,
      title: <T>{'text.confirm'}</T>,
      // text: <T>{'message.are_you_sure'}</T>,
      description: <T>{'message.back_previous_status_confirm'}</T>,
      buttonYesText: <T>{'text.yes'}</T>,
      buttonNoText: <T>{'text.no'}</T>,
      yesCallback: () => {
        if (statusHistory.length === 0) {
          if (dataItem?.status_id && dataItem?.status_id !== "-3") {
            const defaultStatus = "-3"; // Assuming "-3" is the Open status
            setDataItem(prev => {
              return {
                ...prev,
                status_id: defaultStatus
              };
            });
          } else {
            message.warning("No previous status available");
          }
          return;
        }

        const lastChange = statusHistory[statusHistory.length - 1];
        const prevStatus = lastChange?.from;
        
        // Update both states in a synchronous batch
        const newHistory = statusHistory.slice(0, -1);
        setStatusHistory(newHistory);

        setDataItem(prev => {
          const updated = {
            ...prev,
            status_id: prevStatus,
            status_history: JSON.stringify(newHistory)
          };
          return updated;
        });
      },
      noCallback: () => {
        // User cancelled, do nothing
      }
    });
  }

  // console.log('ServiceCall detail debug savedStatusId:', savedStatusId, 'dataItem?.status_id:', dataItem?.status_id);

  const saveData = () => {
    // if (isAttachmentActionsDisabled) {
    //   message.warning(<T>text.cato_status_validation</T>);
    //   return;
    // }

    if (isSat && networkCode !== "YGNITA" && !arrCatoStatusId.includes(dataItem.status_id)) {
      message.warning(<T>text.cato_status_validation</T>);
      return;
    }

    if (isSat && networkCode == "YGNITA" && dataItem.status_id == "-1") {
      message.warning(<T>text.cato_status_validation</T>);
      return;
    }

    if (networkCode !== "YGNITA" && arrStatusId.includes(dataItem.status_id)) {
      message.warning(<T>text.old_status_validation</T>);
      return;
    }

    if (dataItem.status_id === "26" && !dataItem.appointment_date_at) {
      message.warning(<T>text.intervention_status_validation</T>);
      return;
    } else {
      updateData(updateSuccessCallback);
    }
  }

  const isInternalConnectAsLockedStatus = isInternalConnectAs && disabledCatoStatusId.includes(savedStatusId ?? dataItem?.status_id);
  const isAttachmentActionsDisabled = disabledSpecialStatusId.includes(String(savedStatusId ?? ''));

  // console.log( 'ServiceCall detail debug:', dataItem?.status_id, isInternalConnectAs, isInternalConnectAsLockedStatus, disabled, (!isAdmin && !dataItem?.is_saved_status_open));
  // console.log('ServiceCall detail debug dataItem:', dataItem?.status_id);
  return (<>
    {dataItem && <DetailView
      backUrl={Project.getPageUrl(AppPages.ServiceCalls)}
      title={
        <wrap >
          <action>
            <text code="" data-weight="500" data-size="small">{dataItem.call_id}</text>
            <separator vertical=""
            ></separator>
            <Badge
              priority={dataItem.priority}
            />
          </action>
          {(isAdmin || canCreateCall) && !isReadOnlyRole && <action right=''
          >
            <div onClick={openCreateCallDetail} className='button primary adaptive'
            /*eslint-disable-next-line*/
            ><icon>copy</icon><text><T>text.duplicate</T></text></div>
            <div onClick={onSendEmail} className='button primary adaptive'
            ><icon>mail</icon><text><T>text.send_email</T></text></div>           
          </action>}
        </wrap>

      }
    >
      <div className="form_container">
        <view vertical=""
        >
          <Switchable hide={false} name='Collapse' left icon={<icon>collapse</icon>}>
            <view mini="" empty="" scroll_wrapper=''>
              <div className='section_group'>
                <div className='sections'>
                  <form>
                    <InputCont
                      label='text.supplier_code'
                      inputProps={{ disabled: true, name: 'supplier_code', value: dataItem.supplier_code, placeholder: "" }}
                    />
                    <InputCont
                      label='text.call_center'
                      inputProps={{ disabled: true, name: 'call_center', value: dataItem.call_center, placeholder: "" }}
                    />
                    {enableServiceContract &&
                      <cont>
                        <Link
                          style={{ padding: '12px', color: 'var(--main-color)', maxHeight: '40px', minHeight: '40px' }}
                          to={Project.getPageUrl(AppPages.ServiceContractDetails, dataItem.service_contract_uuid)} target="_blank">
                          {dataItem.service_contract_id}
                        </Link>
                        <decor><label>
                          <text>
                            <line></line>
                            <wrap><span><T>text.contract</T></span></wrap></text>
                          <line></line></label>
                          <border></border>
                        </decor>
                      </cont>
                    }
                    {/* <InputCont
                    label='text.call_type'
                    inputProps={{
                      disabled: !isAdmin,
                      type: isAdmin ? 'select' : "text",
                      valuelist: 'call_type',
                      name: 'call_type_id', value: isDispatcher ? dataItem.call_type_id : dataItem.call_type,
                      placeholder: "",
                      onChange: (e) => onChangeData({ target: { name: 'call_type_id', value: e } })
                    }}
                  /> */}
                    <InputCont
                      label='text.call_type'
                      inputProps={{
                        type: 'select',
                        valuelist: 'call_type',
                        name: 'call_type_id',
                        value: dataItem.call_type_id,
                        disableCach: true,
                        placeholder: "",
                        onChange: (e) => onChangeData({ target: { name: 'call_type_id', value: e } })
                      }}
                    />
                    {/* <InputCont
                    label='text.problem_type'
                    inputProps={{
                      disabled: !isAdmin,
                      type: isAdmin ? 'select' : "text",
                      valuelist: 'problem_type',
                      name: 'problem_type_id', value: isAdmin ? dataItem.problem_type_id : dataItem.problem_type,
                      placeholder: "",
                      onChange: (e) => onChangeData({ target: { name: 'problem_type_id', value: e } })
                    }}
                  /> */}
                    <InputCont
                      label='text.problem_type'
                      inputProps={{
                        type: 'select',
                        valuelist: '_problem_type',
                        name: 'problem_type_id',
                        value: dataItem.problem_type_id,
                        parentValue: dataItem.call_type_id,
                        disabled: dataItem.call_type_id === "",
                        disableCach: true,
                        placeholder: "",
                        onChange: (e) => onChangeData({ target: { name: 'problem_type_id', value: e } })
                      }}
                    />
                    <InputCont
                      label='text.appointment_date'
                      inputProps={{
                        validation,
                        disabled: disabled || !(dataItem.is_saved_status_open && dataItem.accepted_at),
                        allowClear: false, 
                        type: 'datetime',
                        name: 'appointment_date_at',
                        dataItem,
                        setDataItem,
                        dataField: 'appointment_date_at',
                        min: new Date()
                      }}
                    />
                    <InputCont
                      label='text.subcontractor'
                      inputProps={{ disabled: true, name: 'subcontractor_name', value: dataItem.subcontractor_name }}
                      icon={!isReadOnlyRole && (isDispatcher) && dataItem.subcontractor_name && 'close'}
                      iconClick={unassignSubcontractor}
                    />
                    <InputCont
                      label='text.subcontractor_phone'
                      inputProps={{ disabled: true, name: 'subcontractor_phone', value: dataItem.subcontractor_phone }}
                    />
                    <InputCont
                      label='text.technician'
                      inputProps={{
                        name: 'technician',
                        type: 'select',
                        valuelist: 'technicians',
                        additionalData: dataItem.societe_uuid,
                        disableCach: true,
                        value: dataItem.technician,
                        placeholder: "",
                        //validation,
                        disabled: isDispatcher,
                        onChange: (e) => onChangeData({ target: { name: 'technician', value: e } })
                      }}
                    />

                    { networkCode === "YGNITA" || arrStatusId.includes(dataItem.status_id) ?
                      <InputCont
                        label='text.status'
                        inputProps={{
                          // disabled: isInternalConnectAsLockedStatus || disabled || (!isAdmin && !dataItem.is_saved_status_open),
                          disabled: disabled || (isInternalConnectAsLockedStatus && savedStatusId == '-1'),// || (!isAdmin && !dataItem.is_saved_status_open),
                          type: !disabled ? 'select' : "text",
                          // type: !disabled && (isAdmin || dataItem.is_saved_status_open) ? 'select' : "text",
                          // valuelist: arrStatusId.includes(dataItem.status_id) ? 'old_status' : (isAdmin ? 'call_status' : 'service_call_update_status_technician'),
                          // valuelist: arrStatusId.includes(dataItem.status_id) ? 'old_status' : (isAdmin ? 'call_status' : 'service_call_update_status_technician'),
                          valuelist: 'call_status',
                          name: 'status_id',
                          // value: !disabled && (isAdmin || dataItem.is_saved_status_open) ? dataItem.status_id : dataItem.status,
                          value: networkCode === "YGNITA" || (!disabled && (isAdmin || dataItem.is_saved_status_open))
                            ? dataItem.status_id
                            : (dataItem.call_status_translation ? dataItem.call_status_translation : dataItem.status),
                          //value: !disabled && (isAdmin || dataItem.is_saved_status_open) ? dataItem.status_id : dataItem.call_status_translation,
                          additionalData: dataItem.status_id,
                          disableCach: true,
                          placeholder: "",
                          onChange: (e) => {
                            if (isSat) {
                              openDescriptionPopup(e);
                            }
                            if (networkCode === "YGNITA") {
                              onYgnitaStatusChange(e);
                            } else {
                              onStatusChange(e);
                            }
                          }
                        }}
                      /> :
                      <>
                        <InputCont
                          label='text.status'
                          inputProps={{
                            // disabled: disabled || (!isAdmin && !dataItem.is_saved_status_open),
                            // type: !disabled && (isAdmin || dataItem.is_saved_status_open) ? 'select' : "text",
                            disabled: isInternalConnectAsLockedStatus,
                            type: 'select',
                            // valuelist: isAdmin ? 'new_call_status' : 'service_call_update_status_technician',
                            valuelist: 'new_call_status',
                            name: 'status_id',
                            //value: !disabled && (isAdmin || dataItem.is_saved_status_open) ? dataItem.status_id : dataItem.call_status_translation,
                            // value: (!disabled && (isAdmin || dataItem.is_saved_status_open) ? dataItem.status_id : (dataItem.call_status_translation ? dataItem.call_status_translation : dataItem.status)),
                            value: dataItem.status_id,
                            additionalData: dataItem.status_id,
                            disableCach: true,
                            placeholder: "",
                            // onChange: 
                            onChange: (e) => {
                              if (isSat) {
                                openDescriptionPopup(e);
                              }
                              onStatusChange(e);
                            }
                          }}
                          icon={(!isInternalConnectAsLockedStatus && dataItem?.status_id !== '-3') ? 'arrowLeft' : null}
                          iconClick={!isInternalConnectAsLockedStatus ? () => backpreviousStatus() : null}
                        />
                        <InputCont
                          label='text.sub_status'
                          inputProps={{
                            // type: !disabled && (isAdmin || dataItem.is_saved_status_open) ? 'select' : "text",
                            type: 'select',
                            name: 'sub_status_id',
                            valuelist: 'new_call_sub_status',
                            //value: !disabled && (isAdmin || dataItem.is_saved_status_open) ? dataItem.status : (dataItem.call_status_translation ? dataItem.call_status_translation : dataItem.status),
                            value: dataItem.sub_status_id,
                            // defaultValue: dataItem.sub_status_id,
                            additionalData: dataItem.status_id,
                            disableCach: true,
                            placeholder: "",
                            onChange: (e) => onChangeData({ target: { name: 'sub_status_id', value: e } }),
                            disabled: !dataItem.sub_status,
                          }}
                        />
                      </>
                    }
                    <InputCont
                      label='text.created_date'
                      inputProps={{
                        disabled: true,
                        name: 'created_at',
                        type: "datetime",
                        dataField: 'created_at_local',
                        dataItem,
                      }}
                    />
                    {isSat && !dataItem.accepted_at && !dataItem.rejected_at && <FieldGroup><DataTip title='text.accept_service_job'><div onClick={onAccept} effect="material" className="button"
                    >
                      <text> <T>text.accept</T> </text> <icon>done</icon>
                    </div> </DataTip>
                      <DataTip title='text.reject_service_job'><div onClick={onReject} effect="material" className="button"
                      >
                        <text><T>text.reject</T></text>
                        <icon>close</icon>
                      </div>
                      </DataTip></FieldGroup>}
                  </form>
                </div>
              </div>
            </view>
          </Switchable>
          <view>
            <TabStrip onChange={(selected) => setTabIndex(selected)} skipSecondaryTabs={isNew} selectedIndex={tabIndex}>
              <div title='text.customer' >
                <Customer {...useDetailResult} disabled={disabled} />
              </div>
              {process.env.REACT_APP_INSTALLER_ENABLED === 'true' && <div title='text.installer' >
                <Installer {...useDetailResult} disabled={disabled} />
              </div>}
              <div title='text.product'>
                <Product {...useDetailResult} disabled={disabled} isReadOnlyRole={isReadOnlyRole} />
              </div>
              <div title='text.remark'>
                <Remark {...useDetailResult} disabled={disabled} />
              </div>
              <div title='text.attachments'>
                <Attachments {...useDetailResult} disabled={isAttachmentActionsDisabled} isReadOnlyRole={isReadOnlyRole} />
              </div>
              <div title='text.fees' skip={!(isDispatcher || isSat || isReadOnlyRole)}
              >
                <Fees {...useDetailResult} disabled={disabled} />
              </div>
              <div title='text.spare_parts' skip={!(isDispatcher || isSat || isReadOnlyRole)}
              >
                <SpareParts {...useDetailResult} disabled={disabled} />
              </div>
              <div title='text.defect_code' skip={!(isDispatcher || isSat || isReadOnlyRole)}
              >
                <DefectCodes {...useDetailResult} isDispatcher={isDispatcher} isReadOnlyRole={isReadOnlyRole} disabled={disabled} saveBlocked={isAttachmentActionsDisabled} />
              </div>
              <div title='text.dpc' skip={/*!(isDispatcher || isSat) ||*/ networkCode === "YGNITA"}
              >
                <DPC {...useDetailResult} disabled={disabled} isReadOnlyRole={isReadOnlyRole}
                />
              </div>
              <div title='text.history'>
                <History {...useDetailResult} disabled={disabled} />
              </div>
            </TabStrip>
          </view>
        </view>
      </div>
      {!disabled && tabIndex < 3 && (
        isMobile ? <div className="fab_container bottom right" style={{ bottom: '28px' }}>
        <div 
          effect="material"
          onClick={(e) => saveData()}
          className="button ant-tooltip-open"
          style={{ backgroundColor: '#fff' }}
          disabled={isReadOnlyRole}
        ><icon>save</icon><T>text.save</T></div>
      </div> : <toolbar>
          <wrap>
            <action right=''
            >
              <div
                onClick={(e) => saveData()}
                className='button'
                disabled={isReadOnlyRole}
              //disabled={!isNotValidated && dataItem.status_id == "2"}
              ><icon>save</icon><T>text.save</T></div>
            </action>
          </wrap>
        </toolbar>
      )}
    </DetailView>
    }
  </>);
}

ServiceCallsDetails.propTypes = {
  windowKey: PropTypes.string,
  data: PropTypes.object,
  openPopup: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  canCreateCall: PropTypes.bool.isRequired,
  enableServiceContract: PropTypes.bool.isRequired,
  internalConnectAs: PropTypes.bool,
  culture: PropTypes.string
};

export default connect(state => ({
  role: state.role,
  canCreateCall: state.userData.canCreateCall,
  internalConnectAs: state.userData?.internalConnectAs,
  culture: state.culture,
  enableServiceContract: state.enableServiceContract
}), dispatch => ({
  dispatch,
  openPopup: (props) => dispatch(openPopup(props))
}))(ServiceCallsDetails);